import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
class MHReceptionSectionDetail extends Vue {

  @Prop({ default: null, type: [Number] })
  id: number
  @Prop({ default: () => [], type: [Array] })
  items: any

  dtIsLoading: boolean;

  dtSectionDetail: {
    character_problem?: { name?: string }
    character_problem_level_2?: { name?: string },
    item_medias: {
      media: { link: null }
    },
    comment?: string
  };
  /**
   *
   */
  constructor() {
    super();
    this.dtSectionDetail = {
      character_problem_level_2: {},
      character_problem: {},
      item_medias: {
        media: { link: null }
      },
      comment: null
    };
    this.dtIsLoading = false;
  }
  get lblSetting() {
    return {
      ...require('@/locales/reception').default
    }
  }
  get textConfigs() {
    return require("@/assets/json-resources/text-field-configs.json")
  }


  get characterProblemName(): string {
    if (this.itemDetail !== undefined && this.itemDetail !== null)
      return (this.itemDetail.character_problem || {}).name
    return ''
  }
  get characterProblemNameLevel2(): string {
    if (this.itemDetail !== undefined && this.itemDetail !== null)
      return (this.itemDetail.character_problem_level_2 || {}).name
    return ''
  }
  get comment(): string {
    return this.itemDetail.comment
  }
  get item_medias() {
    if (this.itemDetail !== undefined && this.itemDetail !== null)
      return this.itemDetail.item_medias
    return []
  }

  get itemDetail() {
    return this.items.find(x => x.id === this.id);
  }

}

export default MHReceptionSectionDetail;


// WEBPACK FOOTER //
// ./src/containers/mh-reception/components/mh-reception-section-detail/index.ts